import React from 'react';
import './App.css';
import Logo from './logo';
import InfoText from './InfoText';

function App() {
  return (
    <div className="App">
      <Logo />
      <InfoText />
    </div>
  );
}

export default App;